 // src/Apollo/index.ts

import client from './client';

export { default as Rehydration } from './Rehydration';

export default client;
